import styled from "styled-components";
import { BREAKPOINTS } from "../../../../app/appConstants";

export const LoginWrapperStyled = styled.div`
    display: flex;
    flex-direction: column;

    > a {
        color: unset;
        text-decoration: underline;
    }
`;
export const LoginWrapperHeaderStyled = styled.div`
    margin: 0;
    padding: 48px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    background: var(--app-bg-header-color);
    
    .logo {
        height: 24px;
    }

    @media (max-width: ${BREAKPOINTS.large}px) {
        padding: 20px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 16px;
        background: var(--color-base);
    }
`;

export const LoginWrapperContentStyled = styled.div`
    flex: 1 1 auto;
`;

export const LoginWrapperMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    font-size: 16px;
    font-weight: 600;

    > button {
        line-height: 32px;
    }
    > *:not(:last-child) {
        margin-right: 16px;
    }
`;

export const LoginWrapperLangChooserContainerStyled = styled.div`
    display: flex;
    align-items: center;
`;
